import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { openViewOrderDialog, openOrderDialog } from '../e-commerce/store/orderSlice';
import {
  getEcomWidgetsOrderItems
} from '../../dashboards/main/store/widgetsSlice';
import { isSupplier, isVasTeam } from './AuraFunctions';

function OrderViewAction({ row, cell, stage, value, loadOrders, loadOrdersFun, toHide = undefined, showEditAction = false, rowValue, paramKey = '', styles = {}, type = null, role = null}) {
  const dispatch = useDispatch();
  const onCellClick = (ev) => {
    ev.stopPropagation();
  };
  let { handleOpen } = row;
  if (!handleOpen) {
    handleOpen = openViewOrderDialog;
  }
  const getDetails = () => {
    let stageValue = { id: '', key: '', widgetId: '' };
    switch (stage) {
      case 'invoice':
        stageValue = {
          id: row.original.invoice_no,
          key: 'invoice_id',
          widgetId: row.original.id
        }
        break;
      case 'container':
      case 'container-management':
        stageValue = {
          id: row.original.container_number,
          key: 'shipment_id',
          widgetId: row.original.shipment_id
        }
        break;
      case "in-production":
        stageValue = {
          id: row.original.container_number,
          key: "shipment_id",
          widgetId: row.original.shipment_id,
        };
        break;
      case 'fulfilled':
        stageValue = {
          id: row.original.order_no,
          key: 'oid',
          widgetId: row.original.id
        }
        break;
      case 'outbound_shipments':
      case 'outbound_shipments_customer':
        stageValue = {
          id: row.original.shipment_no,
          key: 'shipment_id',
          widgetId: row.original.shipment_id
        }
        break;
      default:
        stageValue = {
          id: row.original.order_no,
          key: 'oid',
          widgetId: row.original.id
        }
    }
    return stageValue;
  };

  const getStageTitle = (isTooltipTitle) => {
    const stageData = value || stage
    switch (stageData) {
      case 'fulfilled':
      case 'confirmed':
      case 'order':
        return `View Order Details`;
      case 'quote':
        return `View Quote Details`;
      case 'rfq':
        return `View Rfq Details`;
      case 'invoice':
        return `View Invoice`;
      case 'approval':
        return `View Approval Items`;
      case 'shipment':
        return 'View Shipment';
      case 'container':
        return 'View Container Shipment'
      case 'container-management':
        return 'View Container'
      case 'in-production':
        return 'View In-production'
      case 'outbound_shipments':
      case 'outbound_shipments_customer':
        return 'View Shipment'
      default:
        return "";
    }
  }

  const handleContainerEdit = () => {
    dispatch(
      openOrderDialog({
        completeOrderData: row.original,
        data: row.original,
        param: {
          name: 'container_number',
          title: 'Edit Container Number',
          successMessage: 'Success',
          loadOrdersFun,
          submitButtonName: 'Update',
          isContainerManagement: stage === 'container-management' && isSupplier(role)
        },
        stage,
      })
    );
  }
  
  const containerNumberStyle = {
    display: "inline-block",
    maxWidth: "250px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }

  const stageParam = () => {
    if(stage === "outbound_shipments" || stage === "outbound_shipments_customer") return "shipment"
    return stage === "container" ? "in-production" : stage
  }

  const updateResponseToOrginal = () => {
    return stage === "outbound_shipments" || stage === "outbound_shipments_customer";
  }

  const getDialogData = (payload = []) => {
    if(updateResponseToOrginal()){
      return payload?.orders || []
    }
    return stage === "invoice" ? payload?.invoice : payload
  }

  function getDisplayName(){
    return paramKey ? row.original?.container_number : getDetails().id
  }

  return (
    <Tooltip
      title={paramKey ? row.original?.container_number : getDetails().id}
    >
      <div
        onClick={onCellClick}
        onKeyDown={onCellClick}
        role="button"
        tabIndex="0"
        style={{ cursor: "default", pointerEvents: "auto", ...styles }}
        className="flex flex-row"
      >
        {rowValue || (
          <Tooltip title={getStageTitle(true)}>
            <Typography
              component="div"
              className="py-0 px-2"
              sx={{ cursor: "pointer" }}
              onClick={(ev) => {
                const param = {
                  [getDetails().key]: getDetails().widgetId,
                  stage: stageParam(),
                  invoiceId: true,
                }
                if(stage === "outbound_shipments" || stage === "outbound_shipments_customer") {
                  param.is_outbound = true;
                }
                dispatch(
                  getEcomWidgetsOrderItems(param)
                ).then((data) => {
                  if (data && data.payload) {
                    // setOrderItems(data.payload);
                    // PGSS-4886: viewInvoice returns tax/shipping_cost on the payload root
                    // (not on line items). Merge into header data for the View Invoice popup.
                    const headerData = updateResponseToOrginal()
                      ? { ...data.payload }
                      : stage === 'invoice'
                        ? {
                            ...row.original,
                            tax: data.payload?.tax ?? row.original?.tax,
                            shipping_cost:
                              data.payload?.shipping_cost ?? row.original?.shipping_cost,
                          }
                        : row.original;
                    dispatch(
                      handleOpen({
                        completeOrderData: headerData,
                        stage: stageParam(),
                        data: getDialogData(data?.payload),
                        param: {
                          name: "viewOrder",
                          type: "View",
                          title: getStageTitle(false),
                          showDialogActions: true,
                          is_vas_order: row.original?.is_vas_order,
                          packingSlips: data.payload?.packing_slips || [],
                          supplierInvoices:
                            data.payload?.supplier_invoices || [],
                          loadOrders,
                          toHide,
                          isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',
                          pageType: stage,
                          isContainerManagement: stage === 'container-management' && isSupplier(role),
                        },
                      })
                    );
                  }
                });
              }}
              size="small"
            >
              <div
                className={`flex-row ${
                  (stage === "rfq" || stage === "quote") &&
                  row?.original?.confirmed_order === true &&
                  "text-green-600 font-bold"
                } ${
                  stage !== "container" &&
                  stage !== "in-production" &&
                  "less-text"
                } ${
                  (stage === "invoice") &&
                  row?.original?.is_overdue  === true &&
                  "text-red-600 font-bold"
                } ${
                  (stage === "rfq") &&
                  row?.original?.is_revision_request === true &&
                  "text-purple-500 font-bold"
                }` }
                style={
                  stage === "container" || stage === "in-production" || stage === "container-management"
                    ? containerNumberStyle
                    : {}
                }
              > 
                {getDisplayName()}
                {role && !isVasTeam(role) && !isSupplier(role) && !paramKey && (row.original?.image_customisation === 'vas' || row.original?.image_customisation === 'vas-image') && (
                  <Icon style={{ fontSize: "14px", color: 'red' }} className='ml-2'>brush</Icon>
                )}
              </div>
            </Typography>
          </Tooltip>
        )}
        {showEditAction && (
          <IconButton
            className="py-0 px-2 ml-6"
            size="small"
            onClick={() => handleContainerEdit()}
            color='success'
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
        )}
      </div>
    </Tooltip>
  );
}

export default OrderViewAction;
